import { styled } from "styled-components";

export const TabsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  position: sticky;
  top: 0px;
  background: ${({ theme }) => theme.colors.white};
  margin: ${({ theme }) =>
    `-${theme.spacing.lg} -${theme.spacing.lg} ${theme.spacing.lg} -${theme.spacing.lg}`};
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 99;
`;

export const TabButtonStyled = styled.button<{ $active: boolean }>`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  background: transparent;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.secondary};
  border: none;
  border-bottom: ${({ $active, theme }) =>
    $active ? `3px solid ${theme.colors.primary}` : "3px solid transparent"};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ $active }) => ($active ? "bold" : "normal")};
  transition:
    color 0.3s,
    border-bottom 0.3s;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
